import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect } from "react";
import { useRewardsInfo } from "./store";
import CountUp from "react-countup";

function CreditPoints() {
  const { rewardsData, fetchRewardInfo } = useRewardsInfo();

  useEffect(() => {
    fetchRewardInfo();
  }, []);

  return (
    <div className="d-flex w-100 gap-3">
      <div className="flex-1">
        <CardDiv
          title={<div className="fs-1 ">Total Credited Coin</div>}
          component={
            <div>
              <h4 className="fs-3 fw-medium text-700">
                <CountUp
                  end={rewardsData?.data?.totalCreditedCoinCount}
                  duration={2.75}
                  separator=","
                />
              </h4>
              <h4>(Count)</h4>
            </div>
          }
        />
      </div>
      <div className="flex-1">
        <CardDiv
          title={<div className="fs-1 ">Total Debit Coin</div>}
          component={
            <div>
              <h4 className="fs-3 fw-medium text-700">
                <CountUp
                  end={rewardsData?.data?.totalDebitedCoinCount}
                  duration={2.75}
                  separator=","
                />
              </h4>
              <h4>(Count)</h4>
            </div>
          }
        />
      </div>
      <div className="flex-1">
        <CardDiv
          title={<div className="fs-1 ">Total Expire Coin</div>}
          component={
            <div>
              <h4 className="fs-3 fw-medium text-700">
                <CountUp
                  end={rewardsData?.data?.totalExpiredCoinCount}
                  duration={2.75}
                  separator=","
                />
              </h4>
              <h4>(Count)</h4>
            </div>
          }
        />
      </div>
      <div className="flex-1">
        <CardDiv
          title={<div className="fs-1 ">Total Credited User</div>}
          component={
            <div>
              <h4 className="fs-3 fw-medium text-700">
                <CountUp
                  end={rewardsData?.data?.totalCreditedUserCount}
                  duration={2.75}
                  separator=","
                />
              </h4>
              <h4>(Count)</h4>
            </div>
          }
        />
      </div>
      <div className="flex-1">
        <CardDiv
          title={<div className="fs-1 ">Total Debited User</div>}
          component={
            <div>
              <h4 className="fs-3 fw-medium text-700">
                <CountUp
                  end={rewardsData?.data?.totalDebitedUserCount}
                  duration={2.75}
                  separator=","
                />
              </h4>
              <h4>(Count)</h4>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default CreditPoints;
